import React from 'react'
import { withIcon } from '../../withIcon'

const VIEWBOX_W = 11
const VIEWBOX_H = 7

function toHeightPx (size) {
  if (typeof size === 'number') return size
  const n = parseFloat(String(size).replace(/px$/i, ''))
  return Number.isFinite(n) ? n : 24
}

function LearnerLevelBeginnerIcon (props) {
  const {
    size = 24,
    color = '#000000',
  } = props

  const heightPx = toHeightPx(size)
  const widthPx = heightPx * (VIEWBOX_W / VIEWBOX_H)

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={`${widthPx}px`} height={`${heightPx}px`} viewBox={`0 0 ${VIEWBOX_W} ${VIEWBOX_H}`} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.80551 0.24621C5.23755 -0.105872 5.87458 -0.0802244 6.27719 0.322381L10.6776 4.72277C11.1067 5.15228 11.1067 5.84797 10.6776 6.27746C10.248 6.70704 9.5515 6.70704 9.12192 6.27746L5.49985 2.65539L1.87778 6.27746C1.4482 6.70704 0.751693 6.70704 0.322116 6.27746C-0.107387 5.8479 -0.107357 5.15235 0.322116 4.72277L4.72153 0.322381L4.80551 0.24621Z"
        fill={color}
      />
    </svg>
  )
}

export default withIcon(LearnerLevelBeginnerIcon)
